import React from 'react';
const SvgProcessSuspend = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg width="1em" height="1em" viewBox="0 0 18 20" {...props}>
      <defs>
        <path
          d="M5.275 13.2l-1.075.62.417-2.318 2.181.819-.997.575A3.593 3.593 0 008.574 14.2c.733 0 1.414-.219 1.983-.595l.33.501a4.18 4.18 0 01-2.313.694 4.193 4.193 0 01-3.299-1.6zm7.2-1.041l1.073.619-2.217.798-.381-2.298 1 .577a3.6 3.6 0 00-1.765-4.476l.268-.536a4.2 4.2 0 012.022 5.316zM7.974 6.443V5.2l1.8 1.521-1.8 1.479V7.05a3.601 3.601 0 00-2.994 3.766l-.599.036a4.2 4.2 0 013.593-4.41z"
          id="process-suspend_svg__a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path fill="#CCC" fillRule="nonzero" d="M.6.4v19.2h16.8V5.2h-4.8V.4z" />
        <path fill="#666" fillRule="nonzero" opacity={0.3} d="M17.4 8.8l-4.8-3.6h4.8z" />
        <path fill="#ECECEC" fillRule="nonzero" d="M12.6.4l4.8 4.8h-4.8z" />
        <use fill="#FFF" xlinkHref="#process-suspend_svg__a" />
      </g>
    </svg>
  );
});
export default SvgProcessSuspend;
SvgProcessSuspend.iconName = 'process-suspend';
SvgProcessSuspend.displayName = 'SvgProcessSuspend';
